import { StringField } from "aderant-conflicts-models";
import React from "react";
import { FieldWrapper } from "./FieldWrapper";

interface StringInformationProps {
    field: StringField;
}

export const StringInformation = (props: StringInformationProps) => {
    const {
        field: { fieldLabel, value }
    } = props;
    
    return (
        <FieldWrapper fieldLabel={fieldLabel}>
            {value}
        </FieldWrapper>
    );
};
